@if (title || filterControls.length > 0) {
  <div
    class="d-flex pb-1 mb-2 justify-content-between align-items-end titleBarAppendTo"
    [ngClass]="{
      'pb-3': nativeSectionsService.getClassByLiteralId(literalId) !== 'result',
    }">
    @if (title) {
      <div class="title-bar mb-auto">
        {{ title }}
        @if (contextTitle) {
          | <span class="context-title">{{ contextTitle }}</span>
        }
      </div>
    }
    @for (displayControl of displayControls; track displayControl) {
      <div class="ms-auto">
        <label class="control-label fw-boldish"
          >{{ displayControl.label }}
          @if (displayControl.layoutType === "INPUT_BOX") {
            <input
              type="text"
              pInputText
              [value]="
                chartDataPoints[displayControl.dashboardFieldId]
                  | formatValue
                    : fieldDefinitions[displayControl.dashboardFieldId]
              "
              [disabled]="displayControl?.config?.disable"
              class="d-block {{ displayControl.label }}" />
          }
        </label>
      </div>
    }
    @for (control of filterControls; track control) {
      <div class="ms-auto">
        <label class="control-label"
          >{{ control.label }}
          <m-dropdown
            id="filterControl"
            [options]="control.options"
            [(ngModel)]="control.value"
            (onHide)="filterChange(control)"
            [appendTo]="titleBarAppendTo"
            panelStyleClass="{{ literalId }}"
            class="d-block"></m-dropdown>
        </label>
      </div>
    }
    @if (chartTableToggle !== null) {
      <div>
        <label
          for="chartTableToggleSwitch"
          class="control-label fw-boldish pt-3 px-2"
          >Table
          <m-switch
            id="chartTableToggleSwitch"
            [(ngModel)]="chartTableToggle"
            (onChange)="toggleChange()"
            class="d-block result-slider"></m-switch>
        </label>
      </div>
    }
    @if (showExportIcon && !featureConfigService.isXcdExportHidden(literalId)) {
      <div>
        <m-button
          id="exportIcon"
          type="tertiary"
          styleClass="p-button-icon-only"
          pTooltip="Export"
          tooltipPosition="bottom"
          tooltipStyleClass="saas-tooltip"
          showDelay="800"
          (click)="exportDataHandler($event)">
          <span class="material-symbols-outlined"> ios_share </span>
        </m-button>
        <p-menu
          #exportMenuHtmlElement
          [popup]="true"
          [model]="exportMenu"
          appendTo="body"></p-menu>
      </div>
    }
  </div>
}
